import { render, staticRenderFns } from "./VerificationKtp.vue?vue&type=template&id=53b67c61"
import script from "./VerificationKtp.vue?vue&type=script&lang=js"
export * from "./VerificationKtp.vue?vue&type=script&lang=js"
import style0 from "./VerificationKtp.vue?vue&type=style&index=0&id=53b67c61&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports